import { render, staticRenderFns } from "./memberList.vue?vue&type=template&id=953a06f0&"
import script from "./memberList.vue?vue&type=script&lang=js&"
export * from "./memberList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports